export default __webpack_public_path__ + "static/broderie11.mobile.inspirations-22b80fe3d0506da5c1c9ebd5139056a6.jpg";